// @react
import React, { ReactElement, useState } from 'react'
// @libraries
import DocumentTitle from 'react-document-title'
// @components
import PageTitle from '@bit/atd.web.page-title'
import Grid from '@bit/atd.web.grid'
import Lozenge from '@bit/atd.web.lozenge'
// @module components
import Content from 'modules/activityHistory/components/BookmarksContent'
import PageWrapper from 'modules/activityHistory/components/PageWrapper'

/**
 * 4.0.2 My ATD - Activity History - Bookmarks
 * https://www.figma.com/file/jCo0D2EYkVbuBX1TjR1enA/ATD-MyATD-Desktop-2020?node-id=3247%3A720
 */

const title = 'Activity History - Bookmarks'

const Bookmarks = (): ReactElement => {
  /******************************************
   * PROPS
   ******************************************/

  /******************************************
   * STATE
   ******************************************/

  const [count, setCount] = useState<number>(0)

  /******************************************
   * RENDER
   ******************************************/

  return (
    <PageWrapper>
      <DocumentTitle title={`${title} | ATD`}>
        <>
          <PageTitle>
            <Grid
              container
              direction="row"
              justify="flex-start"
              alignItems="center"
              spacing={2}
            >
              <Grid item>Bookmarks</Grid>
              {count > 0 && (
                <Grid item>
                  <Lozenge size={'normal'}>{`${count} saved`}</Lozenge>
                </Grid>
              )}
            </Grid>
          </PageTitle>
          <Content setCount={setCount} />
        </>
      </DocumentTitle>
    </PageWrapper>
  )
}

export default Bookmarks
